"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var BigNumber_1 = require("./BigNumber");
var Currency = /** @class */ (function () {
    function Currency(address, decimals, symbol, name) {
        if (!BigNumber_1.BN(decimals).isInteger() || BigNumber_1.BN(decimals).isGreaterThan(18)) {
            throw Error("Wrong currency decimals");
        }
        this.decimals = decimals;
        this.symbol = symbol;
        this.name = name;
        this.address = address;
    }
    Currency.prototype.toFactorized = function (amount, decimalPlaces) {
        if (decimalPlaces === void 0) { decimalPlaces = this.decimals; }
        return BigNumber_1.BN(amount)
            .dividedBy(BigNumber_1.BN(10).pow(this.decimals))
            .dp(decimalPlaces)
            .toFixed();
    };
    // with all the decimals applied = Wei
    Currency.prototype.toPrecision = function (amount) {
        return BigNumber_1.BN(amount).multipliedBy(BigNumber_1.BN(10).pow(this.decimals)).dp(0).toFixed();
    };
    Currency.prototype.equals = function (currency) {
        return this.address.toLowerCase() === currency.address.toLowerCase();
    };
    Currency.prototype.sortsBefore = function (other) {
        return this.address.toLowerCase() < other.address.toLowerCase();
    };
    return Currency;
}());
exports.Currency = Currency;
